import { useState } from "react";
import { SarsModel } from "../../domain/SarsModel";
import { EntityDialog, DialogType } from "./types";
import { buildDefinitions } from "./buildDefinitions";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { RenderDialog } from "./RenderDialog";
import { useAuth, useLookup } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";
import { sarsPauseEventLookupService } from "../../services";

export const SarsActivityFeed: React.FC<{
  sarItem: SarsModel;
}> = ({ sarItem }) => {
  const [focusedEntity, setFocusedEntity] = useState<EntityDialog | null>(null);
  const { userType } = useAuth(authSelector);
  const canEdit = userType === UserType.Ofqual;

  const [sarsEventLookups] = useLookup(sarsPauseEventLookupService);

  const definitions = buildDefinitions((activity, dialogType) => {
    setFocusedEntity({
      dialogType: dialogType || DialogType.ActivityAction,
      focusedActivity: activity,
    });
  }, sarItem, sarsEventLookups);

  const defaultActions = [
    {
      label: "Attach email",
      dataTest: "activity-attach-email-button",
      action: () => setFocusedEntity({ dialogType: DialogType.AttachEmail }),
      disabled: false,
    },
  ];

  return (
    <>
      <ActivityFeed
        resourceId={sarItem.id}
        definitions={definitions}
        actions={defaultActions}
      />
      {canEdit && (
        <RenderDialog
          focusedEntity={focusedEntity}
          onClose={() => setFocusedEntity(null)}
          sarItem={sarItem}
        />
      )}
    </>
  );
};
